<form [formGroup]="specialApplianceFG" class="component-container special-appliance-container">
  <div class="ui-g top-border">
    <div class="ui-g-12 form-rows relative-position">
      <div class="ui-g-6 field-rows">
        <label
          class="ui-g-6 field-label text-right-align"
          [class.required]="isSpecialApplianceSectionRequired"
          for="base-data-special-appliance">
          {{ 'facilities-data.form-fields.special-appliance' | translate }}
        </label>
        <p-dropdown
          (onChange)="selectSpecialAppliance($event)"
          [options]="specialAppliances"
          formControlName="specialAppliance"
          [readonly]="isReadOnly"
          id="base-data-special-appliance"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + specialApplianceKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">
                {{ 'lookup.' + specialApplianceKey + '.options.' + option['value'] + '.name' | translate }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <div
        *ngIf="specialApplianceType !== 'wallbox' && specialApplianceType !== 'charger' && specialApplianceType !== 'other'"
        class="ui-g-5"></div>

      <div class="top-right-position padding-top-1" *ngIf="!isReadOnly && displayDeleteButton">
        <div class="pi pi-trash pointer-cursor" (click)="removeElement()"></div>
      </div>
    </div>
    <div class="ui-g-12 form-rows" *ngIf="specialApplianceType === 'other'">
      <div class="ui-g-6 field-rows">
        <label for="base-data-other-appliance" class="ui-g-6 field-label text-right-align"></label>
        <input
          id="base-data-other-appliance"
          class="ui-input pInputText"
          formControlName="other_appliance"
          [readonly]="isReadOnly"
          pInputText />
      </div>
    </div>

    <div class="ui-g-12 form-rows" *ngIf="specialApplianceFG.get('blockIntervals') && specialApplianceType === 'heatpump'">
      <div class="ui-g-6 field-rows">
        <label class="ui-g-6 field-label text-right-align" for="base-data-block-intervals">
          {{ 'facilities-data.form-fields.block-intervals' | translate }}
        </label>
        <p-dropdown
          [options]="blockIntervals"
          formControlName="blockIntervals"
          [readonly]="isReadOnly"
          id="base-data-block-intervals"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + blockIntervalsKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + blockIntervalsKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="ui-g-12 form-rows" *ngIf="showAdditionalData">
      <ng-container *ngIf="!environmentService.copyExistingTechnicalDataConfiguration">
        <div class="ui-g-6 field-rows">
          <label class="ui-g-6 field-label text-right-align" [class.required]="isSpecialApplianceSectionRequired" for="base-data-type">
            {{ 'facilities-data.form-fields.type' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            formControlName="typeName"
            id="base-data-type"
            pInputText
            size="30"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </ng-container>
      <div class="ui-g-6 field-rows">
        <label class="ui-g-6 field-label text-right-align" [class.required]="isSpecialApplianceSectionRequired" for="base-data-amount">
          {{ 'facilities-data.form-fields.amount' | translate }}
        </label>
        <input
          [class]="!environmentService.copyExistingTechnicalDataConfiguration ? 'ui-input pInputText small-width' : 'ui-input pInputText'"
          formControlName="amount"
          id="base-data-amount"
          maxlength="5"
          type="number"
          pInputText
          size="30"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g-12 form-rows">
      <ng-container *ngIf="showAdditionalData && !environmentService.copyExistingTechnicalDataConfiguration">
        <div class="ui-g-6 field-rows">
          <label
            class="ui-g-6 field-label text-right-align"
            [class.required]="isSpecialApplianceSectionRequired"
            for="base-data-manufacturer">
            {{ 'facilities-data.form-fields.manufacturer' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            formControlName="manufacturer"
            id="base-data-manufacturer"
            pInputText
            size="30"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </ng-container>

      <div class="ui-g-6 field-rows">
        <label class="ui-g-6 field-label text-right-align" [class.required]="isSpecialApplianceSectionRequired" for="base-data-power">
          {{ 'facilities-data.form-fields.power' | translate }}
        </label>
        <input
          appFloatNumber="2"
          [class]="!environmentService.copyExistingTechnicalDataConfiguration ? 'ui-input pInputText small-width' : 'ui-input pInputText'"
          formControlName="power"
          id="base-data-power"
          pInputText
          [readonly]="isReadOnly" />
        <span class="unit-margin">{{ allUnits.power }}</span>
      </div>
    </div>
    <div *ngIf="showSubjectToApprovalCheckbox && subjectToApprovalRequirementsMet" class="ui-g-12 form-rows">
      <div class="ui-g-10 text-right-align">
        <p-checkbox
          appEnterClick
          binary="true"
          [readonly]="isReadOnly"
          formControlName="deviceRequiresApproval"
          id="Subject-to=approval"
          label="{{ 'facilities-data.form-fields.device-subject-to-approval' | translate }}"></p-checkbox>
      </div>
    </div>

    <div class="ui-g-12 form-rows">
      <div class="ui-g-4 field-rows">
        <label class="margin-right-align" [class.required]="isSpecialApplianceSectionRequired">
          {{ 'facilities-data.form-fields.controllable-facility' | translate }}
        </label>
      </div>
      <div class="ui-g-2 field-rows">
        <p-radioButton
          formControlName="is_controllable_facility"
          name="controllable-facility"
          [value]="true"
          [label]="'grid-comp.yes' | translate"></p-radioButton>
      </div>
      <div class="ui-g-2 field-rows">
        <p-radioButton
          formControlName="is_controllable_facility"
          name="controllable-facility"
          [value]="false"
          [label]="'grid-comp.no' | translate"></p-radioButton>
      </div>
    </div>

    <div class="ui-g-12 form-rows" *ngIf="showConsumptionDeviceControl && specialApplianceFG.get('is_controllable_facility').value">
      <div class="ui-g-2 field-rows"></div>
      <div class="ui-g-6 field-rows">
        <label class="margin-right-align required commissioning-label" for="consumption-device-control">
          {{ 'facilities-data.form-fields.consumption-device-control' | translate }}
        </label>
        <p-dropdown
          [options]="consumptionDeviceControls"
          formControlName="consumptionDeviceControl"
          [readonly]="isReadOnly"
          id="consumption-device-control"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">
              {{ 'lookup.' + consumptionDeviceControlKey + '.options.' + item['value'] + '.name' | translate }}
            </span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">
                {{ 'lookup.' + consumptionDeviceControlKey + '.options.' + option['value'] + '.name' | translate }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
    <div
      *ngIf="showAdditionalSkiKeyAndDateOfCommissioning && specialApplianceFG.get('is_controllable_facility').value"
      class="ui-g-12 form-rows">
      <div class="ui-g-2 field-rows"></div>
      <div *ngIf="specialApplianceFG.get('skiKey')" class="ui-g-4 field-rows">
        <label class="margin-right-align required">
          {{ 'facilities-data.form-fields.ski-key' | translate }}
        </label>
        <input [readonly]="isReadOnly" class="ui-g-4 ui-input pInputText" formControlName="skiKey" pInputText type="text" maxlength="50" />
      </div>
      <div class="field-rows" [ngClass]="specialApplianceFG.get('skiKey') ? 'ui-g-4' : 'ui-g-6'">
        <label class="margin-right-align required" [class.commissioning-label]="!specialApplianceFG.get('skiKey')">
          {{ 'facilities-data.form-fields.date-of-commissioning' | translate }}
        </label>
        <p-calendar
          [class.commissioning-calendar]="!specialApplianceFG.get('skiKey')"
          tabIndex="0"
          appCalendarEscapeClose
          formControlName="dateOfCommissioning"
          [dateFormat]="dateFormat.dateFormat"
          dataType="string"
          inputId="basic"
          [disabled]="isReadOnly"></p-calendar>
      </div>
    </div>

    <div class="ui-g-12 form-rows">
      <div class="ui-g-4 field-rows">
        <label class="margin-right-align required">{{ 'facilities-data.form-fields.public-device-checkbox' | translate }}</label>
      </div>
      <div class="ui-g-2 field-rows">
        <p-radioButton
          formControlName="is_public_facility"
          name="public-facility"
          [value]="true"
          [label]="'grid-comp.yes' | translate"></p-radioButton>
      </div>
      <div class="ui-g-2 field-rows">
        <p-radioButton
          formControlName="is_public_facility"
          name="public-facility"
          [value]="false"
          [label]="'grid-comp.no' | translate"></p-radioButton>
      </div>
    </div>
    <div *ngIf="specialApplianceFG.controls.module_type" class="ui-g-12 form-rows">
      <div class="ui-g-4 field-rows">
        <label class="margin-right-align" [class.required]="isSpecialApplianceSectionRequired && specialApplianceTypeNotOther">
          {{ 'facilities-data.form-fields.module' | translate }}
        </label>
      </div>
      <div class="ui-g-2 field-rows">
        <p-radioButton
          name="module-type"
          value="module1"
          label="{{ 'facilities-data.form-fields.module1' | translate }}"
          formControlName="module_type"></p-radioButton>
      </div>
      <div class="ui-g-2 field-rows">
        <p-radioButton
          name="module-type"
          value="module2"
          label="{{ 'facilities-data.form-fields.module2' | translate }}"
          formControlName="module_type"></p-radioButton>
      </div>
      <div class="ui-g-2 field-rows">
        <p-radioButton
          name="module-type"
          value="module3"
          label="{{ 'facilities-data.form-fields.module3' | translate }}"
          formControlName="module_type"></p-radioButton>
      </div>
    </div>
    <div *ngIf="specialApplianceFG.controls.zerez_id">
      <div class="ui-g-12">
        <label class="field-label" [class.required]="specialApplianceTypeNotOther" for="zerez_id">
          {{ 'facilities-data.form-fields.zerez-id' | translate }}
        </label>
        <p-inputMask
          class="ui-input pInputText"
          id="zerez_id"
          formControlName="zerez_id"
          [autoClear]="false"
          [mask]="zerezIdMask.mask"
          [characterPattern]="zerezIdMask.charPattern"
          type="text"></p-inputMask>
        <button
          pButton
          type="button"
          style="margin: 1rem"
          [label]="isLoading ? ('technical-data.validating' | translate) : ('technical-data.check-id' | translate)"
          [icon]="isLoading ? 'pi pi-spin pi-spinner' : ' '"
          [disabled]="isReadOnly || isLoading || !specialApplianceFG.get('zerez_id').valid"
          (click)="validateZerezId()"></button>
      </div>
      <span class="unit-margin" innerHTML="{{ 'facilities-data.form-fields.zerez-id-info' | translate }}"></span>
    </div>
  </div>
</form>
